import React from 'react';
import DottedDisk, { DottedDiskProps } from './DottedDisk';
import SphereArrow from './SphereArrow';
import VectorLabel from './VectorLabel';

type Props = DottedDiskProps & {
    tilt: number,
    hideArrow?: boolean,
    flipSide?: boolean,
    azimuth: number,
    label?: string,
    outline?: number,
    numDots?: number,
    arrowScale?: number,
    arrowColor?: number
    textColor?: number
};

export default function VectorDisk({
  tilt,
  label,
  azimuth,
  arrowScale,
  hideArrow,
  arrowColor,
  outline,
  numDots,
  flipSide,
  textColor,
  ...props
}: Props): JSX.Element
{
  return (<DottedDisk {...props} rotation={[ Math.PI * .5, tilt, azimuth ]} outline={outline || 0.03}
    numDots={numDots || 48}>
    {
      !hideArrow && <SphereArrow color={arrowColor === undefined ? props.color : arrowColor}
        scale={[ arrowScale || 1, 1, arrowScale || 1 ]}/>
    }
    {
      label &&
                <VectorLabel height={0.04} text={label} bgColor={arrowColor === undefined ? props.color : arrowColor}
                  padding={0.045} fontSize={19} flipSide={flipSide} textColor={textColor}
                  screenAlign labelOffset={[ 0.1, 0.04 ]}/>
    }
  </DottedDisk>
  );
}

